import * as React from 'react';
const AllergiaIcon = ({ primaryColor, secondaryColor, width }) => {
  const strokePrimary = primaryColor || '#282828';
  const strokeSecondary = secondaryColor || '#ffcf38';
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Livello_2"
      data-name="Livello 2"
      viewBox="0 0 200 200"
      style={{ width }}
    >
      <defs>
        <style>
          {`.cls-1,.cls-2{stroke:${strokePrimary};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.cls-2{stroke:${strokeSecondary}}`}
        </style>
      </defs>
      <path
        d="M123.6 87.45c-.94-2.18-2.66-5.23-5.64-6.32-4.63-1.7-8.2 2.83-13.83 3.14-3.31.18-8.2-1.04-14.39-8.18 0 0-3.37 10.12-13.75 10.22"
        className="cls-2"
      />
      <path
        d="m83.67 125.22-2.11-1.38a17.338 17.338 0 0 1-7.84-14.7v-1.2h-3.04c-2.18 0-3.95-1.77-3.95-3.95v-7.78c0-2.19 1.77-3.96 3.95-3.96h.74V73.06c0-7 5.72-12.66 12.72-12.58L85.86 59a25.676 25.676 0 0 1 16.57-6.19h.15c14.19 0 25.71 11.5 25.71 25.71v13.72h.62c2.18 0 3.95 1.77 3.95 3.95v7.78c0 2.18-1.76 3.95-3.95 3.95h-3.05v1.86a17.31 17.31 0 0 1-8.18 14.65l-.34.21"
        className="cls-2"
      />
      <path
        d="m102.84 123.1.42 5.45 1.36 17.63c.07.86 1.05 1.3 1.73.79a16.62 16.62 0 0 1 9.91-3.28c.71 0 1.41.04 2.12.13l.23.03c.85.11 1.48-.75 1.13-1.53l-7.82-17.33-8.46-18.76c-.94-2.08-3.86-2.15-4.9-.11l-9.76 19.24-6.1 12c-.41.8.28 1.72 1.16 1.56 1.35-.25 2.72-.36 4.08-.36 3.77 0 7.49.92 10.85 2.72l1.64.88M122.17 130.14l6.25 8.01M127.74 126.5l5.52 1.58M78.57 130.14l-6.25 8.01M73 126.5l-5.52 1.58"
        className="cls-1"
      />
      <path
        d="M118.66 96.18c0 2.15-2.4 3.9-5.37 3.9s-5.37-1.74-5.37-3.9M93.48 96.18c0 2.15-2.4 3.9-5.37 3.9s-5.37-1.74-5.37-3.9"
        className="cls-2"
      />
    </svg>
  );
};
export default AllergiaIcon;
